export const ROLE_SUPERADMIN = 'superadmin';
export const ROLE_COMPANY_ADMIN = 'owner';
export const ROLE_DEPARTMENT_ADMIN = 'depadmin';
export const ROLE_CONTENT_MANAGER = 'employee';
